import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/management/add.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-595f026c")

_pushScopeId("data-v-595f026c")
const _hoisted_1 = { class: "twoBlocksContainer justify-content-start" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_file_selector = _resolveComponent("file-selector")!
  const _component_removable_image = _resolveComponent("removable-image")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_localized_text, {
      class: "fs_12 greyBlue d-block mt-1 mb-3",
      localizedKey: "app_creagallery",
      text: "Crea gallery"
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_file_selector, {
        class: "block addPhotoSquare",
        modelValue: _ctx.tempFile,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.tempFile = $event))
      }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tempFiles, (item, i) => {
        return (_openBlock(), _createBlock(_component_removable_image, {
          class: "block galleryItem",
          key: i,
          style: 'background-image: url(\'' + item +'\');',
          onRemove: ($event: any) => (_ctx.removeImage(i))
        }, null, 8, ["style", "onRemove"]))
      }), 128))
    ])
  ], 64))
})